import { createSlice } from '@reduxjs/toolkit';

import asyncThunks from './async-thunks';
import extraReducers from './extra-reducers';
import { CustomerGroupSelectorState } from './types';

const initialState: CustomerGroupSelectorState = {
  context: null,
  customerServiceUrl: '',
  data: [],
  isError: false,
  isLoading: false,
};

const slice = createSlice({
  extraReducers: (builder) => {
    extraReducers.getContext(builder);
    extraReducers.getData(builder);
    extraReducers.putContext(builder);
  },
  initialState,
  name: 'api',
  reducers: {
    setContext: (state, action) => {
      state.context = action.payload;

      const customerContextChangedEvent = new CustomEvent(
        'customer-context-changed',
        {
          detail: action.payload,
        },
      );
      window.dispatchEvent(customerContextChangedEvent);
    },
    setCustomerServiceUrl: (state, action) => {
      state.customerServiceUrl = action.payload;
    },
  },
});

const api = {
  getContext: asyncThunks.getContext,
  getData: asyncThunks.getData,
  putContext: asyncThunks.putContext,
  reducer: slice.reducer,
  requestTopLevelCustomer: asyncThunks.requestTopLevelCustomer,
  setContext: slice.actions.setContext,
  setCustomerServiceUrl: slice.actions.setCustomerServiceUrl,
};

export default api;
